module.exports = __webpack_public_path__ + "img/132.8639ac0a.jpg";